module.exports = __webpack_public_path__ + "static/img/img05.685624f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/en/en001/sp/img05.jpg
// module id = HA9c
// module chunks = 0